import React from "react";

const MessageContext = React.createContext({});

const MessageProvider = MessageContext.Provider;

export { MessageContext };
export default MessageProvider;
